<template>
    <div ref="app" id="app">
        <base-notifications
            class="z-50"
            :show="notification.show"
            v-on:close="closeNotification"
            :error="notification.error"
        >
            <template v-slot:title>{{ notification.title }}</template>
            <template v-slot:content>
                {{ notification.content }}
            </template>
        </base-notifications>
        <router-view v-on:showNotification="showNotification" />
        <!-- v-if="!isMobile()" -->
        <!-- v-if="isMobile()" -->
        <!-- <div class="flex flex-col items-center justify-center ">
            <img src="Restricte-MobileDevice.svg" class=" w- h-2/3 cover" />
            <p class="text-3xl text-center text-blue-600">
                Notre application est disponible exclusivement sous format web.
                <br />
                Veuillez vous connecter via votre ordinateur pour une expérience
                optimale
            </p>
        </div> -->
    </div>
</template>

<script>
import "./assets/styles/index.css";
import { isMobileMixin } from "@/mixins/isMobileMixin.js";

export default {
    mixins: [isMobileMixin],
    data() {
        return {
            notification: {
                show: false,
                error: false,
                content: "",
                title: ""
            }
        };
    },
    methods: {
        showNotification(notification) {
            this.notification.content = notification.content;
            this.notification.title = notification.title;
            this.notification.error = notification.error;
            this.notification.show = true;
            setTimeout(() => (this.notification.show = false), 4000);
        },
        closeNotification() {
            this.notification = {
                show: false,
                content: "",
                title: "",
                error: true
            };
        }
    }
};
</script>

<style>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Montserrat:wght@100;200;300;400;500;600;700&family=Poppins:wght@100;300;400;500;600&display=swap" rel="stylesheet">
#app {
    /* font-family: Avenir, Helvetica, Arial, sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}
</style>
